import { Box, Heading, lgBumps } from '@wrisk/ui-components'
import { TFunction } from 'i18next'
import React, { FunctionComponent } from 'react'

import { TKeyBuilder } from '../../../infrastructure/internationalisation'
import { HeadingStaticBlock } from '../../../state/configuration'

export const StaticHeading: FunctionComponent<{
  t: TFunction
  tKey: TKeyBuilder
  item: HeadingStaticBlock
}> = ({ t, tKey, item }) => (
  <Box key={item.name} width={1} borderTopWidth={1}>
    <Heading mt={lgBumps} as='h2' typoSize='lg'>
      {t(tKey(item.name, 'header'))}
    </Heading>
  </Box>
)
